import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import './index.less';

const Popover = ({ title, children }) => {
    const likeRef = useRef(null);
    const popoverRef = useRef(null);

    const [showPopover, setShowPopover] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    const handleMouseEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (likeRef.current) {
            const rect = likeRef.current.getBoundingClientRect();
            const popoverRect = popoverRef.current.getBoundingClientRect();
            setCoords({
                top: rect.top - (popoverRect.height + 20),
                left: rect.left + rect.width / 2,
            });
            setShowPopover(true);
        }
    };

    const handleMouseLeave = () => {
        setShowPopover(false);
    };

    return (
        <div className='popover-container'>
            <span ref={likeRef}
                className="popover-title"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}>
                {title}
            </span>
            {children &&
                <div ref={popoverRef} className={classNames('popover-content', { visible: showPopover })}
                    style={{
                        position: "fixed",
                        top: coords.top,
                        left: coords.left,
                    }}>
                    {children}
                </div>
            }
        </div>
    );
};

export default Popover;